export default {
  pt: {
    pageTitle: "Pagamento via Pix",
    mainTitle: "Escaneie o QR Code",
    description:
      "Abra o app do seu banco e escaneie o código abaixo, ou copie o código Pix, para efetuar o pagamento.",
    copyButton: "Copiar código",
    copiedToastTitle: "Copiado!",
    copiedToastDescription: "Código Pix copiado para a área de transferência.",
    copyErrorToastTitle: "Não foi possível copiar",
    copyErrorToastDescription: "Copie o código manualmente.",
    expiresInLabel: "Expira em",
    entryLabel: "Entrada",
    waitingPaymentText: "Aguardando confirmação do pagamento...",
    reissuingText: "Gerando um novo código Pix...",
    loadErrorToastTitle: "Não foi possível gerar o Pix",
    loadErrorToastDescription: "Tente novamente em instantes.",
    failedMessage: "Houve um erro ao processar seu pagamento. Por favor, tente novamente.",
    successTitle: "Pagamento confirmado!",
    successDescription: "Recebemos o seu pagamento via Pix.",
  },

  en: {
    pageTitle: "Pix Payment",
    mainTitle: "Scan the QR Code",
    description:
      "Open your bank app and scan the code below, or copy the Pix code, to complete the payment.",
    copyButton: "Copy code",
    copiedToastTitle: "Copied!",
    copiedToastDescription: "Pix code copied to clipboard.",
    copyErrorToastTitle: "Could not copy",
    copyErrorToastDescription: "Copy the code manually.",
    expiresInLabel: "Expires in",
    entryLabel: "Down payment",
    waitingPaymentText: "Waiting for payment confirmation...",
    reissuingText: "Generating a new Pix code...",
    loadErrorToastTitle: "Could not generate the Pix code",
    loadErrorToastDescription: "Please try again shortly.",
    failedMessage: "There was an error processing your payment. Please try again.",
    successTitle: "Payment confirmed!",
    successDescription: "We've received your Pix payment.",
  },
};
